
/*
Defines the custom element <ravel-led-array>
*/

import { RavelLedArray } from './src/RavelLedArray.js';

customElements.define('ravel-led-array', RavelLedArray);
